function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M189.833 66.2083C187.684 64.0623 184.202 64.0632 182.055 66.2122L127.657 120.679L73.1919 66.0833C71.0459 63.9353 67.5639 63.9292 65.4139 66.0752C63.2639 68.2202 63.2589 71.7023 65.4049 73.8523L119.884 128.461L65.407 183.006C63.261 185.156 63.2629 188.639 65.4119 190.785C66.4859 191.857 67.892 192.392 69.299 192.392C70.7079 192.392 72.116 191.855 73.1909 190.779L127.654 136.248L182.054 190.777C183.128 191.853 184.538 192.392 185.948 192.392C187.353 192.392 188.759 191.857 189.832 190.787C191.982 188.641 191.987 185.158 189.841 183.008L135.427 128.465L189.839 73.9854C191.984 71.8373 191.982 68.3553 189.833 66.2083ZM128.305 1.36328C58.2769 1.36328 1.30493 58.3363 1.30493 128.363C1.30493 198.392 58.2769 255.363 128.305 255.363C198.333 255.363 255.305 198.392 255.305 128.363C255.305 58.3353 198.333 1.36328 128.305 1.36328ZM128.305 244.363C64.3429 244.363 12.3049 192.326 12.3049 128.363C12.3049 64.4003 64.3429 12.3633 128.305 12.3633C192.267 12.3633 244.305 64.4003 244.305 128.363C244.305 192.326 192.268 244.363 128.305 244.363Z",
  fill: "black"
});

function SvgIconCloseBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseBig);
export default __webpack_public_path__ + "static/media/icon-close-big.d964bba8ac6261df784ff27cde3eca0d.svg";
export { ForwardRef as ReactComponent };